import { useEffect, useState } from "react";
import React from "react";
import GenericModal from "components/Modal";
import DeleteConfirmationModal from "components/Modal/DeleteConfirmationModal";
import httpClient from "services/network/httpClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import Farmers from "./Farmers";
import AddFarmers, { FarmersProps } from "./AddFarmers";
import FarmerDetails from "./FarmerDdetails";
import UpdateFarmerDetails from "./UpdateFarmerDetails";
import { showToast } from "components/Toaster";
import { sortByName } from "utility/sorting";

interface FarmerActionCellProps {
  row: object;
  onEdit: (row: any) => void;
  onView: (row: any) => void;
  onDelete: (row: any) => void;
}

const FarmerActionCell: React.FC<FarmerActionCellProps> = ({ row, onEdit, onView, onDelete }) => (
  <div className="flex space-x-2">
    <button
      type="button"
      onClick={() => onEdit(row)}
      className="px-2 py-2 rounded-lg cursor-pointer"
      aria-label="Edit farmer"
    >
      <FontAwesomeIcon icon={faEdit} />
    </button>
    <button
      type="button"
      onClick={() => onView(row)}
      className="px-2 py-2 rounded-lg cursor-pointer"
      aria-label="View farmer"
    >
      <FontAwesomeIcon icon={faEye} />
    </button>
    <button
      type="button"
      onClick={() => onDelete(row)}
      className="px-2 py-2 rounded-lg cursor-pointer"
      aria-label="Delete farmer"
    >
      <FontAwesomeIcon icon={faTrash} />
    </button>
  </div>
);

const EmployeesList = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>();
  const [vieData, setVieData] = useState<FarmersProps>();
  const [isView, setIsView] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const getData = () => {
    setLoading(true);
    httpClient
      .get("farmers/all?page=1&size=2000")
      .then((res: any) => {
        console.log("getting all Farmers response ");
        sortByName(res.value.contents, "farmerName");
        setData(res.value.contents);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleEdit = (row: any) => {
    setIsEdit(true);
    setEditData(row);
  };

  const handleView = (row: any) => {
    setIsView(true);
    setVieData(row);
  };

  const handleDelete = (row: any) => {
    setDeleteData(row);
    setIsDelete(true);
  };

  const deleteFuction = () => {
    httpClient
      .delete(`farmers/delete/${deleteData.id}?isDeleted=true`)
      .then((res) => {
        if (res.success === true) {
          getData();
          showToast(`Farmer ${deleteData.farmerName} Details Deleted Successfully`, "success");
        } else {
          showToast(`${res.error.message}`, "error");
        }
      })
      .catch((error) => {
        console.info("Inside Error");
        console.log(error);
        showToast("something went wrong", "error");
      })
      .finally(() => {
        console.info("you are in finally block");
        setIsDelete(false);
        getData();
      });
  };

  const tableData = [
    {
      key: "farmerName",
      label: "Farmer Name",
      bold: true,
    },

    {
      key: "farmerContactNumber",
      label: "Contact Number",
      bold: true,
    },
    {
      key: "houseNumber",
      label: "House Number",
      bold: true,
    },
    {
      key: "village",
      label: "village",
      bold: true,
    },
    {
      key: "district",
      label: "district",
      bold: true,
    },
    {
      key: "state",
      label: "State",
      bold: true,
    },
    {
      key: "tehsilMandal",
      label: "Tehsil Mandal",
      bold: true,
    },
    {
      key: "pinCode",
      label: "PIN Code",
      bold: true,
    },
    {
      key: "actions",
      label: "Actions",
      excludeExport: true,
      actions: (row: object) => (
        <FarmerActionCell row={row} onEdit={handleEdit} onView={handleView} onDelete={handleDelete} />
      ),
    },
  ];

  const handleAdd = () => {
    setIsAdding(true);
  };

  return (
    <div>
      <div className="">
        <div className="overflow-x-auto">
          <Farmers
            data={data}
            columns={tableData}
            loading={loading}
            onAdd={handleAdd}
            title="Farmer List"
          />
        </div>{" "}
      </div>
      {isAdding && (
        <GenericModal
          isOpen={isAdding}
          onClose={() => setIsAdding(false)}
          customWidth="md:max-w-6xl"
          header="Add Farmer"
        >
          <AddFarmers
            getData={getData}
            onClose={() => setIsAdding(false)}
          ></AddFarmers>
        </GenericModal>
      )}
      {isEdit && editData && (
        <GenericModal
          isOpen={isEdit}
          onClose={() => setIsEdit(false)}
          header="Update Farmer Details "
          customWidth="md:max-w-6xl"
        >
          <UpdateFarmerDetails
            data={editData}
            onClose={() => setIsEdit(false)}
            getData={getData}
          />
        </GenericModal>
      )}
      {isView && vieData && (
        <GenericModal
          isOpen={isView}
          onClose={() => setIsView(false)}
          header={vieData.farmerName || "Farmer Details"}
          customWidth="md:max-w-lg"
        >
          <FarmerDetails data={vieData} onClose={() => setIsView(false)} />
        </GenericModal>
      )}
      {isDelete && (
        <DeleteConfirmationModal
          isOpen={isDelete}
          onClose={() => setIsDelete(false)}
          onConfirm={deleteFuction}
          entityName="Farmer"
          title="Delete Farmer"
        />
      )}
    </div>
  );
};

export default EmployeesList;
